import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import axios from "axios";

/**
 * The sentryconf endpoint is handled by the Flow UI nginx web server
 * and configured within nginx.conf in this project
 *
 * We make a request to this endpoint to check if sentry should be enabled
 * for the environment that we're running in
 */
axios
	.get("/sentryconf")
	.then(res => {
		if (res.data["sentry-enabled"] === true) {
			Sentry.init({
				dsn: "https://7818cbbefed141689937df0a6ce0a47d@o987404.ingest.sentry.io/5952117",
				integrations: [new Integrations.BrowserTracing()],
				environment: process.env.NODE_ENV,
				release: "flow@" + process.env.REACT_APP_PACKAGE_VERSION,
				// Set tracesSampleRate to 1.0 to capture 100%
				// of transactions for performance monitoring.
				// We recommend adjusting this value in production
				tracesSampleRate: 1.0,
			});
		}
	})
	.catch(err => {
		// If you are running a dev server locally this request will return an error
		// we just swallow it, no need to log anything
	});
